import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const images = ['/img/intro-bg.jpg'];

const Slider = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const mouse = useRef({ X: 0, Y: 0, CX: 0, CY: 0 });
  const blockPos = useRef({ CX: 0, CY: 0 });
  const blockRef = useRef(null);

  const goNext = () => {
    setPrevIndex(activeIndex);
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const goPrev = () => {
    setPrevIndex(activeIndex);
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  // Mouse move + parallax effect
  useEffect(() => {
    const block = blockRef.current;
    if (!block) return;

    const onMouseMove = (e) => {
      const rect = block.getBoundingClientRect();
      mouse.current.X = e.clientX - rect.left - rect.width / 2;
      mouse.current.Y = e.clientY - rect.top - rect.height / 2;
    };

    const onMouseLeave = () => {
      mouse.current.X = mouse.current.CX;
      mouse.current.Y = mouse.current.CY;
    };

    block.addEventListener('mousemove', onMouseMove);
    block.addEventListener('mouseleave', onMouseLeave);

    const interval = setInterval(() => {
      blockPos.current.CY += (mouse.current.Y - blockPos.current.CY) / 12;
      blockPos.current.CX += (mouse.current.X - blockPos.current.CX) / 12;

      block.style.transform = `scale(1.03) translate(${blockPos.current.CX * 0.02}px, ${blockPos.current.CY * 0.02}px) rotateX(${blockPos.current.CY * 0.02}deg) rotateY(${blockPos.current.CX * 0.02}deg)`;

      const circleLight = block.querySelector('.circleLight');
      if (circleLight) {
        circleLight.style.background = `radial-gradient(circle at ${mouse.current.X}px ${mouse.current.Y}px, #b10000ff, transparent)`;
      }
    }, 20);

    return () => {
      block.removeEventListener('mousemove', onMouseMove);
      block.removeEventListener('mouseleave', onMouseLeave);
      clearInterval(interval);
    };
  }, []);

  // Autoplay
  useEffect(() => {
    const autoSlide = setInterval(() => {
      goNext();
    }, 10000);
    return () => clearInterval(autoSlide);
  }, []);

  return (
    <div className="slider">
      <div className="items-group">
        <div className="item active">
          {/* Background layers */}
          {prevIndex !== null && (
            <div className="bg-pair">
              <div
                className="blur"
                style={{ backgroundImage: `url(${images[prevIndex]})` }}
              ></div>
              <div
                className="bg"
                style={{ backgroundImage: `url(${images[prevIndex]})` }}
              ></div>
            </div>
          )}
          <div className="bg-pair show">
            <div
              className="blur"
              style={{ backgroundImage: `url(${images[activeIndex]})` }}
            ></div>
            <div
              className="bg"
              style={{ backgroundImage: `url(${images[activeIndex]})` }}
            ></div>
          </div>

          {/* Center Block */}
          <div className="block" ref={blockRef}>
            <span className="circleLight"></span>
            <div className="text">
              <h2>
                {props.data ? props.data.title : 'Loading'}
                <span></span>
              </h2>
              <p>{props.data ? props.data.paragraph : 'Loading'}</p>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginTop: '20px',
              }}
            >
              <Link to="/projects" className="btn btn-projects btn-lg">
                Projects
              </Link>
              <Link to="/how-it-works" className="btn btn-custom btn-lg">
                How Mahanc Works
              </Link>
              <Link to="/idea" className="btn btn-ideas btn-lg">
                Ideas
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="navigations">
        <ul className="dots">
          {images.map((_, i) => (
            <li
              key={i}
              className={i === activeIndex ? 'active' : ''}
              onClick={() => {
                setPrevIndex(activeIndex);
                setActiveIndex(i);
              }}
            ></li>
          ))}
        </ul>
      </div>

      {/* Arrows 
      <button className="slider-btn prev-btn" onClick={goPrev}>
        &#10094;
      </button>
      <button className="slider-btn next-btn" onClick={goNext}>
        &#10095;
      </button>
      */}
    </div>
  );
};

export default Slider;
